import { render } from "./PropertyChange.vue?vue&type=template&id=3cb03fc0&scoped=true"
import script from "./PropertyChange.vue?vue&type=script&lang=js"
export * from "./PropertyChange.vue?vue&type=script&lang=js"

import "./PropertyChange.vue?vue&type=style&index=0&id=3cb03fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb03fc0"]])

export default __exports__